import { ApolloClient } from '@apollo/client';
import { DataStoreOptions } from '../hooks/useDataStore';
import { createQueries } from '../hooks/useDataStore/useQueries';
import createDataStore from '../hooks/useDataStore/createDataStore';

export const createDataSource = <T>(client: ApolloClient, options: DataStoreOptions<T>) => {
  const dsQueries = createQueries(client, options);
  return createDataStore(dsQueries, options);
};
